import React, { useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import * as userActions from "../../redux/actions/userActions";

const Logout = ({ actions, history }) => {
  useEffect(() => {
    actions
      .getUserData()
      .then((storedValues) => {
        // attn: this isn't currently getting hit (see logout button handler in footer)
        if (Object.keys(storedValues)) {
          window.localStorage.clear();
        } else {
          history.push("/cookbook");
        }
      })
      .catch(() => {
        history.push("/cookbook");
      });
  }, []);
  return (
    <>
      <div className="jumbotron">
        <h3> You have been successfully signed out. {"\u{1F44B}"}</h3>
      </div>
    </>
  );
};

Logout.propTypes = {
  actions: PropTypes.object.isRequired,
  history: PropTypes.object,
};

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      signout: bindActionCreators(userActions.signout, dispatch),
      getUserData: userActions.getUserData,
    },
  };
}
export default connect(null, mapDispatchToProps)(Logout);
